@if (visibility()) {
  <div class="h-full z-55"><span class="whirly-loader"></span></div>
}
